<template>
    <footer class="app-footer">
        <!-- Hình nền trang trí bên trên Footer (nếu cần giữ lại giống cũ) -->
        <!-- <div class="footer-bg-wrapper">
            <img src="@/assets/images/bg-footer.png" alt="Footer Background" class="footer-bg-img" />
        </div> -->

        <div class="footer-container">
            <!-- Cột thông tin bản quyền và thương hiệu -->
            <div class="footer-brand">
                <div class="brand-title">{{ $t('nav.logo_text') || 'Lễ hội Trái cây Đồng Tháp' }}</div>
                <p class="copyright">
                    © {{ currentYear }} {{ $t('nav.organization') }}.
                </p>
            </div>

            <!-- Cột liên kết điều hướng nhanh -->
            <!-- <nav class="footer-nav">
                <a class="nav-link" href="#">Thông tin liên hệ</a>
                <a class="nav-link" href="#">Chính sách bảo mật</a>
                <a class="nav-link" href="#">Sơ đồ trang</a>
                <a class="nav-link" href="#">Hỗ trợ kỹ thuật</a>
            </nav> -->
        </div>
    </footer>
</template>

<script>
export default {
    name: "Footer",
    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    }
};
</script>

<style scoped>
.app-footer {
    background-color: var(--color-public-bg, #f7fbf0);
    /* margin-top: 40px; */
    font-family: var(--font-body, "Inter");
}

.footer-bg-wrapper {
    width: 100%;
    padding: 0;
    display: flex;
    justify-content: center;
}

.footer-bg-img {
    width: 100%;
    display: block;
    object-fit: cover;
}

.footer-container {
    max-width: var(--container-max, 1280px);
    margin: 0 auto;
    padding: 40px var(--spacing-gutter, 24px);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
}

@media (min-width: 768px) {
    .footer-container {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
}

.footer-brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

@media (min-width: 768px) {
    .footer-brand {
        align-items: flex-start;
    }
}

.brand-title {
    font-family: var(--font-heading, "Montserrat");
    font-size: 18px;
    font-weight: 700;
    color: var(--color-public-primary, #0d631b);
}

.copyright {
    font-size: 14px;
    color: var(--color-public-text-body, #40493d);
    margin: 0;
    text-align: center;
}

@media (min-width: 768px) {
    .copyright {
        text-align: left;
    }
}

.footer-nav {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
}

.nav-link {
    font-size: 14px;
    font-weight: 500;
    color: var(--color-public-text-body, #40493d);
    text-decoration: none;
    transition: color 0.2s ease;
}

.nav-link:hover {
    color: var(--color-public-secondary, #ff8f06);
}
</style>